import { t } from "@ebay/i18n-ebay";
import { getPropsForViewTracking, getModuleMetaTracking, getPropsForEmptyMapViewTracking, getPropsForAutoLoadTracking } from "../../utils/tracking";
import { extractFilter, isPriceFilterActive } from "./helpers/filter";
import { textFromTD } from "../../utils/text";
import { DESKTOP_BANNER_INSERT_POSITIONS, MIN_DESKTOP_WIDTH, MIN_MOBILE_WIDTH, MOBILE_BANNER_INSERT_POSITIONS } from "./const";
import { MapDialog } from "./types";
$ const { layout, listingsView, isMobile, isRecommendationsView, model, waitingForService, apiKey, marketplaceId, favoritesSettings, locality } = (
  input || {}
);
$ const {
  itemConditionPillData,
  pricePillData,
  watchlistPillData,
  highlightedItem,
  prevHighlightedItem,
  isFilterConditionDialogOpen,
  watchListItems,
  pointsOfInterest,
  clusterPointsOfInterest,
  selectedItems,
  prevSelectedItems,
  isLoadingMoreItems,
  windowWidth,
  leftRailItems,
  isLoading,
  isAutoLoadTrackerVisible,
  availableFilters,
  postalCodePillData,
  isLocationChangeDialogOpen,
  userLocationZipcode,
  isFilterPriceDialogOpen,
  isEmptyMapTrackerVisible,
  meta,
  isLeftRailItemHover,
  showErrorMessage,
  resetMapviewButton,
  isPreviewCardEnabled,
  mapMessage,
  showLocateMeButton,
  locateMe,
  userLocationCoordinates,
  help,
  shouldOpenMapHelp,
  survey,
  surveyButton,
  isWatchlistPillActive,
  expandedView,
  filteredPointsOfInterest,
  showPostcodeInquiry,
  banners,
  controlButtons,
} = state;
$ const shouldShowLeftRail = listingsView === "left-rail" && windowWidth >= MIN_DESKTOP_WIDTH;
$ const shouldShowCarousel = clusterPointsOfInterest.length > 0 && selectedItems.length > 0 && !shouldShowLeftRail;
$ const singleItemSelected = selectedItems.length === 1;
$ const prevSingleItemSelected = prevSelectedItems.length === 1;
$ const showFetchLoader = isLoadingMoreItems && !isAutoLoadTrackerVisible;
$ const isLeftRailLoading = waitingForService || isLoading || showFetchLoader;
$ const showNoResultsBanner = shouldShowLeftRail && !isLoadingMoreItems && leftRailItems?.length < pointsOfInterest?.length;
$ const filterCondition = extractFilter(availableFilters, "condition");
$ const filterPrice = extractFilter(availableFilters, "price");
$ const hasItemsOnMap = (pointsOfInterest?.length ?? 0) > 0;
$ const conditionFilterActive = !!filterCondition?.options?.find((option) => option.isEnabled);
$ const priceFilterActive = filterPrice ? isPriceFilterActive(filterPrice) : false;
$ const availableConditions = pointsOfInterest?.map((poi) => textFromTD(poi.itemCard?.itemCondition)).filter((c) => c !== undefined) || [];
$ const isFeedLayout = listingsView === "feed";
$ const isMapExpanded = expandedView === "map";
$ const shouldShowFeed = isFeedLayout && !isMapExpanded;
$ const areFiltersActive = conditionFilterActive || priceFilterActive;
$ const feedBannerInsertPositions = windowWidth >= MIN_MOBILE_WIDTH ? DESKTOP_BANNER_INSERT_POSITIONS : MOBILE_BANNER_INSERT_POSITIONS;

<map-postcode-inquiry
  mapParamsGathering=model?.mapParamsGathering
  visible=showPostcodeInquiry
  userLocationZipcode=userLocationZipcode
  on-close("onPostcodeInquiryClose")
  on-submit("onLocationChangeDialogSubmit")
/>

<div
  data-testid="map-container"
  class=[
    "map-wrapper",
    `map-layout-${layout}`,
    `map-listings-view-${listingsView}`,
    showPostcodeInquiry && "map-wrapper-hidden",
    (singleItemSelected || shouldShowCarousel) && "map-hide-controls",
    isLeftRailItemHover && "map-listings-view-left-rail__hovering",
    isMapExpanded && "map-expanded-view",
  ]
>
  <if(component.watchInstance && favoritesSettings?.localizedContent)>
    <watch-handler watchDataProvider=component.watchInstance localizedContent=favoritesSettings?.localizedContent/>
  </if>
  <map-location-change-dialog
    apiKey=apiKey
    marketplaceId=marketplaceId
    postalCodePillData=postalCodePillData
    open=isLocationChangeDialogOpen
    userLocationZipcode=userLocationZipcode
    on-close("onDialogClose", MapDialog.LocationChange)
    on-submit("onLocationChangeDialogSubmit")
  />
  <if(filterCondition && hasItemsOnMap && itemConditionPillData)>
    <map-filter-dialog
      filterKey="condition"
      open=isFilterConditionDialogOpen
      itemPillData=itemConditionPillData
      filter=filterCondition
      availableConditions=availableConditions
      on-close("onDialogClose", MapDialog.FilterCondition)
      on-submit("onSubmitFilter")
    />
  </if>
  <if(filterPrice && pricePillData)>
    <map-filter-dialog
      filterKey="price"
      open=isFilterPriceDialogOpen
      itemPillData=pricePillData
      filter=filterPrice
      on-close("onDialogClose", MapDialog.FilterPrice)
      on-submit("onSubmitFilter")
    />
  </if>

  <if(isEmptyMapTrackerVisible || isAutoLoadTrackerVisible)>
    <div id="map-tracker-container">
      <if(isAutoLoadTrackerVisible && meta?.trackingList)>
        <div id="map-tracker-auto-load" ...getPropsForAutoLoadTracking(meta?.trackingList)>
          <a href="#" class="clipped" tabindex="-1" aria-hidden="true">
            Auto Load tracker
          </a>
        </div>
      </if>
      <if(isEmptyMapTrackerVisible)>
        <div id="map-tracker-empty" ...getPropsForEmptyMapViewTracking(getModuleMetaTracking(model))>
          <a href="#" class="clipped" tabindex="-1" aria-hidden="true">
            Empty map tracker
          </a>
        </div>
      </if>
    </div>
  </if>
  <context
    locality=(locality ?? {})
    watchListItems=watchListItems
    handleWatchListItemToggle=component.handleWatchListItemToggle.bind(component)
    watchInstance=component.watchInstance
    localizedContent=favoritesSettings?.localizedContent
  >
    <if(shouldShowLeftRail)>
      <items-left-rail
        pointsOfInterest=pointsOfInterest
        leftRailItems=leftRailItems
        isLoading=isLeftRailLoading
        highlightedItem=highlightedItem
        prevHighlightedItem=prevHighlightedItem
        showErrorMessage=showErrorMessage
        isLeftRailItemHover=isLeftRailItemHover
        prevSelectedItems=prevSelectedItems
        selectedItems=selectedItems
        cta=resetMapviewButton
        isPreviewCardEnabled=isPreviewCardEnabled
        on-cta-click("onShowAll")
        on-item-hover("onItemHover")
        on-unhover-item("onUnhoverItem")
      />
    </if>
    <if(showNoResultsBanner && mapMessage)>
      <map-message mapMessage=mapMessage on-cta-click("onShowAll")/>
    </if>
    <if(isMobile || isFeedLayout)>
      <div class="map-data-controls-wrapper">
        <div class=`map-data-controls ${showFetchLoader ? "map-data-controls__disabled" : ""}`>
          <if(postalCodePillData)>
            <map-location-change
              zipcode=postalCodePillData.postalCode
              distance=postalCodePillData.distance
              on-location-btn-click("onDialogOpen", MapDialog.LocationChange)
              locationChangeClickAction=postalCodePillData.action
            />
          </if>
          <map-watchlist-pill selected=isWatchlistPillActive on-watchlist-pill-click("onWatchlistPillClick") watchlistPillData=watchlistPillData/>
          <if(filterPrice && pricePillData)>
            <map-filter-pill
              itemPillData=pricePillData
              expanded=isFilterPriceDialogOpen
              selected=priceFilterActive
              on-filter-pill-click("onDialogOpen", MapDialog.FilterPrice)
            />
          </if>
          <if(filterCondition && hasItemsOnMap && itemConditionPillData)>
            <map-filter-pill
              itemPillData=itemConditionPillData
              expanded=isFilterConditionDialogOpen
              selected=conditionFilterActive
              on-filter-pill-click("onDialogOpen", MapDialog.FilterCondition)
            />
          </if>
        </div>
        <if(postalCodePillData)>
          <map-location-tourtip/>
        </if>
      </div>
    </if>
    <if(shouldShowFeed)>
      <items-feed
        pointsOfInterest=pointsOfInterest
        feedItems=(areFiltersActive ? filteredPointsOfInterest : pointsOfInterest)
        highlightedItem=highlightedItem
        prevHighlightedItem=prevHighlightedItem
        showErrorMessage=showErrorMessage
        prevSelectedItems=prevSelectedItems
        selectedItems=selectedItems
        on-item-hover("onItemHover")
        on-unhover-item("onUnhoverItem")
        isWatchlistPillActive=isWatchlistPillActive
        areFiltersActive=areFiltersActive
        isLoading=showFetchLoader || isLoading
        bannerInsertPositions=feedBannerInsertPositions
        banners=banners
      />
    </if>

    <div class="map-info-wrapper">
      <if(isFeedLayout)>
        <div class="map-top-view-controls">
          <map-expand isMapExpanded=isMapExpanded on-cta-click("toggleExpandedView")/>
          <map-zoom on-zoom-in("handleZoomIn") on-zoom-out("handleZoomOut") zoomIn=controlButtons?.zoomIn zoomOut=controlButtons?.zoomOut/>
        </div>
      </if>

      <div data-testid="map" id="map" class="map" key="map" no-update-body ...getPropsForViewTracking(getModuleMetaTracking(model))/>

      <if(showFetchLoader)>
        <map-fetch-loader/>
      </if>
      <if(isRecommendationsView)>
        <if(showErrorMessage && !shouldShowLeftRail)>
          <ebay-page-notice class="map-notice" icon="none" status="education">
            <p data-testid="map-notice-text">
              ${t("mapview/map", "loadMoreErrorMessage")}
            </p>
          </ebay-page-notice>
        </if>
      </if>
      <if(isWatchlistPillActive && watchListItems?.length === 0)>
        <ebay-page-notice class="map-notice empty-watchlist-notice" icon="none" status="education">
          <p data-testid="map-empty-watchlist-notice-text">
            ${t("mapview/map", "watchlistEmptyMessage")}
          </p>
        </ebay-page-notice>
      </if>
      <if(areFiltersActive && filteredPointsOfInterest?.length === 0 && !isWatchlistPillActive)>
        <ebay-page-notice class="map-notice empty-filters-notice" icon="none" status="education">
          <p data-testid="map-empty-filters-notice-text">
            ${t("mapview/map", "noFilteredItemsMessage")}
          </p>
        </ebay-page-notice>
      </if>

      <div class="map-view-controls">
        <if(showLocateMeButton)>
          <map-locate-me locateMe=locateMe on-cta-click("onUserLocationCenter") disabled=!userLocationCoordinates/>
        </if>

        <map-help help=help overrideOpen=shouldOpenMapHelp/>
        <if(isMobile && survey && !isFeedLayout)>
          <map-survey class="map-user-feedback-icon-button" type="icon-button" model=survey/>
        </if>
        <if(!isMobile)>
          <if(!isFeedLayout)>
            <map-zoom on-zoom-in("handleZoomIn") on-zoom-out("handleZoomOut") zoomIn=controlButtons?.zoomIn zoomOut=controlButtons?.zoomOut/>
          </if>
          <if(surveyButton && shouldShowLeftRail)>
            <map-survey class="map-user-feedback-button" type="button" model=surveyButton/>
          </if>
        </if>
        <if(survey && isFeedLayout)>
          <map-survey class="map-user-feedback-icon-button" type="icon-button" model=survey/>
        </if>
      </div>
    </div>

    <if(isFeedLayout)>
      <map-toggle-view expandedView=expandedView on-toggle-view("toggleExpandedView")/>
    </if>

    <if(singleItemSelected && !shouldShowLeftRail)>
      <map-item
        itemCard=(pointsOfInterest[selectedItems[0]].itemCard)
        watchListItems=watchListItems
        handleWatchListItemToggle=component.handleWatchListItemToggle.bind(component)
        key=String(highlightedItem)
      />
    </if>
    <if(prevSingleItemSelected && pointsOfInterest[prevSelectedItems?.[0]])>
      <map-item
        itemCard=(pointsOfInterest[prevSelectedItems[0]].itemCard)
        isPrev
        watchListItems=watchListItems
        handleWatchListItemToggle=component.handleWatchListItemToggle.bind(component)
        key=String(prevHighlightedItem)
      />
    </if>
    <if(shouldShowCarousel)>
      <items-carousel pointsOfInterest=clusterPointsOfInterest/>
    </if>
  </context>
</div>
<if(input.waitingForService)>
  <div class="map-loading" data-testid="map-loading">
    <ebay-progress-spinner size="large"/>
  </div>
</if>
